import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'bc-maintenance-mode-page',
  templateUrl: './maintenance-mode-page.component.html',
  styleUrls: ['./maintenance-mode-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class MaintenanceModePageComponent {}
